import React, { useEffect, useState } from 'react';
import { useLinesContext } from '../../../contexts/Lines';
import { makeStyles } from '@material-ui/core/styles';
import { applicationStatus } from '../../../utils';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles((theme: any) => ({
  menu: {
    backgroundColor: 'transparent',
    marginTop: theme.spacing(2),
    '& .MuiList-padding': {
      padding: 0,
    },
    borderRadius: theme.spacing(1),
  },
  customOptionText: {
    cursor: 'pointer',
    fontWeight: 'bold',
    width: '350px',
    backgroundColor: theme.palette.brand.greyLight,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  header: {
    marginBottom: theme.spacing(1),
    cursor: 'default',
    fontWeight: 'bold',
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
    '& .MuiSelect-select.MuiSelect-select': {
      paddingBottom: 0,
      paddingRight: 0,
    },
  },
  selectorButton: {
    transform: ({ open }: any) => (open ? 'rotate(180deg)' : ''),
    cursor: ({ lineOnEditMode }: any) =>
      lineOnEditMode ? 'default' : 'pointer',
  },
}));

export default function FilterPlan({
  filterPlan,
  setFilterPlan,
  setFilterName,
}) {
  const [open, setOpen] = useState(false);
  const { applications, lineOnEditMode } = useLinesContext();
  const classes = useStyles({ open, lineOnEditMode });

  useEffect(() => {
    if (filterPlan) {
      setFilterName(getNameFromId(filterPlan));
    } else setFilterName('All Plans');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterPlan]);

  const plans = applications
    ?.map((plan) => {
      const isCloneApp =
        plan.status === applicationStatus.submitted.typeId &&
        plan.originApplication;
      if (
        plan.status !== applicationStatus.archived.typeId &&
        plan.status !== applicationStatus.rejected.typeId &&
        !isCloneApp
      )
        return {
          value: plan.id,
          label: plan.displayName || plan.name,
        };
      return undefined;
    })
    .filter((product) => product !== undefined);

  plans?.unshift({
    value: 'null',
    label: 'All Plans',
  });

  const getNameFromId = (id: string) => {
    const name = plans.filter((plan) => plan.value === id);
    return name[0].label;
  };

  const onOpen = () => {
    setOpen(!open);
  };

  return (
    <>
      <Select
        className={classes.header}
        value=""
        disableUnderline
        disabled={lineOnEditMode}
        onClick={onOpen}
        open={open}
        onChange={(e) => {
          if (e.target.value === 'null') {
            setFilterPlan(null);
          } else {
            setFilterPlan(e.target.value);
          }
        }}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          getContentAnchorEl: null,
          className: classes.menu,
        }}
        IconComponent={() => (
          <div onClick={onOpen}>
            <img
              src={'icons/arrowMenuOpener.svg'}
              alt={'Arrow menu opener'}
              className={classes.selectorButton}
            />
          </div>
        )}
      >
        {plans?.map((product, i) => (
          <MenuItem
            value={product.value}
            key={i}
            className={classes.customOptionText}
          >
            {product.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
}
